/// <amd-module name="TFS/Admin/OrganizationAadControls/Components/AadDisconnectDialog/AadDisconnectDialog" />
import React = require("react");
import AdminResources = require("TFS/Admin/OrganizationAadControls/Resources");
import { Dialog } from "VSSUI/Dialog";
import { format, equals } from "VSS/Core/Util/String";
import { TextField } from "VSSUI/TextField";
import { ObservableValue } from "VSS/Core/Observable";
import { createMarkup } from "TFS/Admin/Common/Util/HtmlString";
import { filterXSS } from "xss";
import { VssComponent } from "VSS/Platform/Layout";
import { IAadDisconnectDialogComponentProps } from "TFS/Admin/OrganizationAadCommon/Contracts/ComponentControls.props";

interface IAadDisconnectDialogComponentState {
    userInputMatchOrgName: boolean;
    userInputOrgName: ObservableValue<string>;
}

export class AadDisconnectDialogComponent extends React.Component<IAadDisconnectDialogComponentProps, IAadDisconnectDialogComponentState> {
    public constructor(props: IAadDisconnectDialogComponentProps) {
        super(props);

        this.state = {
            userInputMatchOrgName: false,
            userInputOrgName: new ObservableValue<string>("")
        };
    }

    public render(): JSX.Element {
        return (
            <Dialog
                calloutContentClassName="aad-disconnect-dialog"
                onDismiss={() => this.props.onDismiss()}
                titleProps={{ text: AdminResources.DisconnectAadTitle }}
                footerButtonProps={[
                    {
                        onClick: this.props.onDismiss,
                        text: AdminResources.Cancel
                    },
                    {
                        onClick: this.props.onDisonnect,
                        text: AdminResources.Disconnect,
                        disabled: !this.state.userInputMatchOrgName,
                        primary: true,
                        className: "disconnect-aad-button"
                    }
                ]}
            >
                <div className="top-margin">
                    <span
                        dangerouslySetInnerHTML={createMarkup(
                            format(AdminResources.AadDisconnectConfirmation, filterXSS(this.props.orgTenantData.displayName))
                        )}
                    />
                </div>
                <div className="top-margin">
                    <span
                        dangerouslySetInnerHTML={createMarkup(
                            format(AdminResources.AadDisconnectEnterOrgName, filterXSS(this.props.organizationName))
                        )}
                    />
                </div>
                <div className="top-margin">
                    <TextField
                        onChange={this._onNameChanged}
                        value={this.state.userInputOrgName}
                        ariaLabel={AdminResources.AadDisconnectEnterOrgName}
                    />
                </div>
            </Dialog>
        );
    }

    private _onNameChanged = (event: any, value: string) => {
        value = filterXSS(value);
        this.setState({
            userInputOrgName: new ObservableValue<string>(value)
        });

        if (equals(value, this.props.organizationName, true)) {
            this.setState({
                userInputMatchOrgName: true
            });
        } else {
            this.setState({
                userInputMatchOrgName: false
            });
        }
    };
}

VssComponent.register("ms.vss-admin-web.aad-disconnect-dialog", AadDisconnectDialogComponent);
